import React, { Component} from 'react';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import Nav from './SideNav/sideNav';
import './header.css';

class Header extends Component {
  state = {
    showNav: false
  }
  
  onHideNav = () => {
    this.setState({
      showNav:false
    })
  }
  render(){
    return(
      <header>
        <div className="open_nav">
          <FontAwesome name="bars" className="fa-2x"
          onClick={()=>this.setState({showNav:true})}
            style={{
              color:'deeppink',
              padding:'10px',
              cursor:'pointer',
              marginRight: '4vh'
            }}
          />
        </div>
        <Nav 
          showNav={this.state.showNav}
          onHideNav={()=>{this.onHideNav()}}
        />
        <Link to='/' >
          <img src={process.env.PUBLIC_URL + ('/images/fitv_logo.png')} alt="fitv" className="logo"/>
        </Link>
      </header>
    )
  }
}

export default Header;